
interface IRowData {
    [key: string]: any;
}


/**
 * Generates a CSV string
 * @param arrayOfObjects Array of objects to parse
 * @param csvKeys Array of keys if undefined will generate from the first item in the array
 * @param csvHeaders Array of headers in the position of the key
 */
export default function generateCSV<T>(arrayOfObjects: T[], csvKeys?: string[], csvHeaders?:string[]):string {
    if (arrayOfObjects === undefined) {
        throw new Error("No items to parse");
    }
    if (!Array.isArray(arrayOfObjects)) {
        throw new Error("array of objects is not an array");
    }

    const keys = generateCSVKeys(arrayOfObjects[0], csvKeys);

    const headers = generateCSVHeaders(csvHeaders || keys);

    let csvString = `${headers} \n`;
    csvString += arrayOfObjects.map((rowData) => generateCSVRow(rowData, keys)).join(` \n`);
    return csvString;
}

/**Generates the csv keys either by the keys array or if the first element of the array is an object */
function generateCSVKeys<T>(firstElementOfArray: T, csvKeys?: string[]) {
    if(csvKeys !== undefined){
        return csvKeys;
    }
    if(typeof firstElementOfArray === "object"){
        return Object.keys(firstElementOfArray);
    }
    throw new Error("Failed getting header keys");
}

/**Generates the headers via the keys array */
function generateCSVHeaders(objectKeys: string[]) {
    return objectKeys.join(",");
}

/**Generates the row using the object keys, if no data for key then pushes empty string */
function generateCSVRow<T extends IRowData>(rowData: T, objectKeys: string[]) {
    const rowArray = [];
    for (const keys of objectKeys) {
        const rowItem = rowData[keys];
        if (rowItem === undefined) {
            rowArray.push(`""`);
        } else {
            if(typeof rowItem === "string"){
                rowArray.push(`"${rowItem.replace(/['",]+/g, '')}"`);
            }
            else rowArray.push(`"${rowItem}"`);
        }
    }
    return rowArray.join(",");
}